import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _get from "lodash/get";

var _createReducer;

import { createReducer } from 'redux-act';
import { getCreditFactorHistory, getCreditProfileRecentChanges, getCreditProfileAlerts } from "../actions";
export default createReducer((_createReducer = {}, _defineProperty(_createReducer, getCreditFactorHistory.success, function (state, payload) {
  return _objectSpread(_objectSpread({}, state), payload);
}), _defineProperty(_createReducer, getCreditProfileRecentChanges.success, function (state, payload) {
  return _objectSpread(_objectSpread({}, state), {}, {
    recent_changes: _get(payload, 'recent_changes'),
    no_changes_data: _get(payload, 'no_changes_data')
  });
}), _defineProperty(_createReducer, getCreditProfileAlerts.success, function (state, payload) {
  return _objectSpread(_objectSpread({}, state), payload);
}), _createReducer), {});